import { useEffect, useState } from "react";
import api from "@/lib/api";
import { apiErr } from "@/lib/format";
import { DownloadSimpleIcon } from "@phosphor-icons/react";

const fh = (iso) => {
  const d = new Date(iso);
  return `${d.toLocaleDateString("es-HN", { day: "2-digit", month: "2-digit", year: "numeric" })} – ${d.toLocaleTimeString("es-HN", { hour: "numeric", minute: "2-digit" })}`;
};

/** Bitácora de actividad de la factura: descargas del PDF en orden cronológico. Solo lectura. */
export default function BitacoraFactura({ facturaId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get(`/invoices/${facturaId}/descargas`).then(({ data: d }) => setData(d)).catch((e) => setError(apiErr(e)));
  }, [facturaId]);
  return (
    <section className="mt-2 mb-5 bg-app/60 border border-border rounded-lg p-4" data-testid="bitacora-factura">
      <h4 className="text-sm font-semibold">Bitácora de actividad de la factura</h4>
      <p className="text-[11px] text-text-muted mb-3">Registro interno de descargas del PDF. No se puede modificar ni eliminar.</p>
      {error ? <p className="text-xs text-red-300">{error}</p>
        : !data ? <p className="text-xs text-text-muted">Cargando…</p>
          : data.items.length === 0 ? <p className="text-xs text-text-secondary" data-testid="bitacora-vacia">Aún no hay descargas registradas.</p> : (
            <ol className="space-y-3">
              {data.items.map((x) => (
                <li key={x.id} className="border-l-2 border-agro-green/50 pl-3 text-xs" data-testid={`bitacora-${x.id}`}>
                  <div className="font-semibold text-text-primary">{fh(x.fecha)}</div>
                  <div><span className="text-text-muted">Usuario:</span> {x.usuario_nombre}{x.rol ? ` – ${x.rol}` : ""} <span className="text-text-muted">({x.usuario})</span></div>
                  <div className="flex items-center gap-1"><span className="text-text-muted">Acción:</span> <DownloadSimpleIcon size={12} aria-hidden="true" /> {x.accion}</div>
                  <div><span className="text-text-muted">Comentario:</span> {x.nota || "—"}</div>
                </li>
              ))}
            </ol>
          )}
    </section>
  );
}
